var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoPrefixArrowRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.735 4.655a1 1 0 0 1 .08 1.257l-.08.1-4 4.333a1 1 0 0 1-1.55-1.26l.08-.097L3.64 5.333.265 1.678A1 1 0 0 1 .235.356l.087-.09A1 1 0 0 1 1.644.234l.09.087 4 4.333z",
    id: "e4i31sci0a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7 5)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "x5c6azb4sb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e4i31sci0a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    fillRule: "nonzero",
    xlinkHref: "#e4i31sci0a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#x5c6azb4sb)",
    fill: "#9EA0A5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-7-5h20v20H-7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPrefixArrowRight);
export default __webpack_public_path__ + "static/media/ico-prefix-arrow-right.52b5889ff6f7a967b3d54d5bf5baede2.svg";
export { ForwardRef as ReactComponent };